import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
const IMG_LOGO_GOYANES_URL = new URL('../../img/logo.jpg', import.meta.url).href;

const GoyanesNavbar = () => {
  return (
    <Navbar bg="light" expand="lg" sticky='top'>
      <Container className="d-flex justify-content-between align-items-center">
        <Navbar.Brand href="/">
          <img
          src={IMG_LOGO_GOYANES_URL}
          alt={"Logo goyanes"}
          width="30"
          height="30">
          </img>
          &nbsp;
          Goyanes Somoza</Navbar.Brand>
        <div className="d-flex align-items-center">
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link href="/">Inicio</Nav.Link>
              <Nav.Link href="/empresa">Empresa</Nav.Link>
              <Nav.Link href="/contacto">Contacto</Nav.Link>
              <Nav.Link href="http://www.goyanesonline.com">Catálogo</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </div>
      </Container>
    </Navbar>
  );
}

export default GoyanesNavbar;